import React from 'react';
import { ArticleBreadcrumbs } from '../../../../components/ArticleBreadcrumbs';
import { ArticleTitle } from '../../../../components/ArticleTitle';
import { ReadTime } from '../../../../components/ReadTime';
import { CamelizedArticleResponse } from '../../../../types/api';
import { Flex } from '../../../../wag-react/next-components/Flex';
export type WellnessArticleHeaderProps = Pick<CamelizedArticleResponse, 'readTime' | 'breadcrumbs'> & {
  title: string;
};
export const WellnessArticleHeader = ({
  breadcrumbs,
  readTime,
  title
}: WellnessArticleHeaderProps) => <>
    {breadcrumbs && <ArticleBreadcrumbs value={breadcrumbs} fontSize={['12px', '14px']} />}

    <Flex flexDirection={['column', null, 'column-reverse']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {readTime && <ReadTime>
          {readTime.text}
        </ReadTime>}

      <ArticleTitle color="#474747" data-sentry-element="ArticleTitle" data-sentry-source-file="index.tsx">
        {title}
      </ArticleTitle>
    </Flex>
  </>;